/**
 * @file new-address.component.ts
 */
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MultilingualService } from 'src/app/core/services/multilingual/multilingual.service';
import { firstLastNamePattern, states } from 'src/app/main/main.constants';
import { AppInsightsService } from 'src/app/services/app-insights/app-insights.service';
import { OrderService } from 'src/app/services/order/order.service';
import { AppCenterAnalytics, AppCenterAnalyticsAPIMsgs } from '../../services/app-insights/app-insights';

@Component({
  selector: 'app-new-address',
  templateUrl: './new-address.component.html',
  styleUrls: []
})
export class NewAddressComponent implements OnInit {
  isLoading = false;
  isError = false;
  addressForm: UntypedFormGroup;
  states = states;
  errorMsg!: string;

  @ViewChild('error', { read: TemplateRef }) errorTemplate!: TemplateRef<any>;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly dialogRef: MatDialogRef<NewAddressComponent>,
    private readonly orderService: OrderService,
    private readonly appInsightsService: AppInsightsService,
    public readonly multilingualService: MultilingualService,
    private readonly snackBar: MatSnackBar,
  ) {
    this.addressForm = this.buildAddressForm();
  }

  ngOnInit(): void {
    this.appInsightsService.trackPageView(AppCenterAnalytics.ADD_ADDRESS_FORM_VIEWED);
  }

  buildAddressForm(): UntypedFormGroup {
    return this.fb.group({
      addressLine1: ['', [Validators.required]],
      addressLine2: [''],
      careOfName: ['', [Validators.pattern(firstLastNamePattern)]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      zipCode: ['', [Validators.required, Validators.minLength(5)]],
    });
  }


  get addressLine1(): UntypedFormControl {
    return this.addressForm.get('addressLine1') as UntypedFormControl;
  }

  get city(): UntypedFormControl {
    return this.addressForm.get('city') as UntypedFormControl;
  }

  get state(): UntypedFormControl {
    return this.addressForm.get('state') as UntypedFormControl;
  }

  get zipCode(): UntypedFormControl {
    return this.addressForm.get('zipCode') as UntypedFormControl;
  }

  addAddress(): void {
    this.isLoading = true;
    this.isError = false;
    let responseText = AppCenterAnalyticsAPIMsgs.COMMON_INITIAL_MSG;
    this.orderService.addShippingAddress(this.addressForm.value).subscribe((res) => {
      this.isLoading = false;
      responseText = AppCenterAnalyticsAPIMsgs.SUCCESS_ADD_SHIPPING_ADDRESS;
      this.dialogRef.close({ dialogStatus: 0 });
      this.appInsightsService.trackPageView(`${AppCenterAnalytics.ADD_ADDRESS_FORM_VIEWED} ${AppCenterAnalytics.COMMON_API_CALL}`, { formData: this.addressForm.value, Response: responseText });
    }, (error) => {
      this.isError = true;
      this.isLoading = false;
      this.errorMsg = error;
      responseText = error ? error : AppCenterAnalyticsAPIMsgs.ERROR_ADD_SHIPPING_ADDRESS;
      this.appInsightsService.trackPageView(`${AppCenterAnalytics.ADD_ADDRESS_FORM_VIEWED} ${AppCenterAnalytics.COMMON_API_CALL}`, { formData: this.addressForm.value, Response: responseText });
      this.snackBar.openFromTemplate(this.errorTemplate, {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      //this.dialogRef.close(1);
    });

  }

}
